import { ValidateMessages } from "../component/validation/IValidation";
import { JSON } from '../interface/IDefine';

const valueFromValid = (_v: ValidateMessages, inLabel?: boolean): JSON => {
  // console.debug("valueFromValid", _v, props, defines)
  if (typeof _v !== "object") return _v;
  if (Array.isArray(_v)) {
    return _v.map(__v => valueFromValid(__v.value, inLabel));
  }
  return Object.keys(_v).reduce((p, key) => {
    const item = _v[key];
    // console.debug(item)
    const retVal = typeof item === "object" && Object.keys(item).includes("value")
      ? valueFromValid(item.value as ValidateMessages, inLabel) : item;
    p[key] = inLabel ? {
      label: item?.label || "", value: retVal
    } : retVal;
    return p;
  }, {} as {[key: string]: any})
}
export default valueFromValid;